if (!window.Eurus.loadedScript.has('gift-card-recipient.js')) {
  window.Eurus.loadedScript.add('gift-card-recipient.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xGiftCardRecipent', (sectionId, message_email_required, message_email_invalid, message_send_on, error_message_wrapper) => ({
        showForm: false,
        recipient_control: 'if_present',
        validateEmail: { 'show': true, 'message': ''},
        validateDate: { 'show': false, 'message': ''},
        disabled: true,
        variantDisabled: new Map(),
        onVariantChange: null,
        onRecipientInput: null,
        init() {
          this.$refs.timezone_offset.value = new Date().getTimezoneOffset().toString();
          this.captureVariantState();
          this.onVariantChange = (event) => {
            if (event.detail?.html) this.captureVariantState(event.detail.html);
            this.syncButtonState();
          };
          this.onRecipientInput = (event) => {
            if (event.target === this.$refs.recipient_email || event.target === this.$refs.recipient_send_on) {
              this.onChangeInput(event.target);
            }
          };
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, this.onVariantChange);
          this.$el.addEventListener('input', this.onRecipientInput);
          this.$nextTick(() => this.syncButtonState());
        },
        destroy() {
          document.removeEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, this.onVariantChange);
          this.$el.removeEventListener('input', this.onRecipientInput);
        },
        buyButtons() {
          return document.querySelectorAll(`#product-form-${sectionId} .add_to_cart_button, #product-form-sticky-${sectionId} .add_to_cart_button`);
        },
        captureVariantState(html) {
          this.buyButtons().forEach((button) => {
            const source = html ? html.getElementById(button.id) : button;
            this.variantDisabled.set(button.id, !source || source.disabled);
          });
        },
        syncButtonState() {
          const recipientForm = document.getElementById(`recipient-form-${sectionId}`);
          if (!recipientForm) return;
          this.disabled = this.showForm && (this.validateEmail.show || this.validateDate.show);
          recipientForm.dataset.disabled = String(this.disabled);
          const available = document.getElementById(`x-atc-button-${sectionId}`)?.dataset.available === 'true';
          this.buyButtons().forEach((button) => {
            button.disabled = this.variantDisabled.get(button.id) !== false || !available || this.disabled;
          });
        },
        onChange() {
          if ( this.$refs.recipient_checkbox.checked) {
            this.showForm = true;
            this.recipient_control = 'on';
          } else {
            this.showForm = false;
            this.recipient_control = 'if_present';
          }
          this.setForm();
        },
        onChangeInput(el) {
          if (el.type == 'email') {
            if (el.value === '') {
              this.validateEmail = { 'show': true, 'message': message_email_required };
            } else if (!el.validity.valid) {
              this.validateEmail = { 'show': true, 'message': message_email_invalid };
            } else {
              this.validateEmail = { 'show': false, 'message': '' };
            }
            this.syncButtonState();
            return this.validateEmail.show;
          }

          if (el.type == 'date') {
            if (el.value === '' && !el.validity.badInput) {
              this.validateDate = { 'show': false, 'message': '' };
              el.required = false;
            } else {
              const today = new Date().toLocaleDateString('en-CA');
              const maxDate = new Date(Date.now() + 90*24*60*60*1000).toLocaleDateString('en-CA');
              const invalid = el.validity.badInput || el.value < today || el.value > maxDate;
              this.validateDate = { 'show': invalid, 'message': invalid ? message_send_on : '' };
              el.required = invalid;
            }
            this.syncButtonState();
            return this.validateDate.show;
          }
        },
        setForm() {
          document.getElementById(`recipient-form-${ sectionId }`).querySelectorAll('.recipient_input').forEach((input) => {
            input.value = '';
          })
          this.$refs.recipient_error_message.classList.add('hidden');
          
          this.validateDate = { 'show': false, 'message': '' };
          this.validateEmail = { 'show': true, 'message': '' };
          this.$refs.recipient_send_on.required = false;
          this.$nextTick(() => this.syncButtonState());
        },
        handleShowResult() {
          Object.entries(error_message_wrapper).forEach(([key, value]) => {
            if (key == 'email') {
              this.validateEmail = { 'show': true, 'message': value[0] };
            }
            if (key == 'send_on') {
              this.validateDate = { 'show': true, 'message': value[0] };
            }
          });
          this.syncButtonState();
        }
      }))
    });
  });
}
